<script lang="ts" setup>
const { auth } = $store()
if (process.server) {
  const accessToken = auth.setAccessToken('')
}
</script>
